<template>
  <v-app id="inspire">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-container>
          <v-card-title style="text-align: center; font-size: 32px; font-weight: 1000;">{{status}}</v-card-title>
          <v-layout row wrap style="margin-left: 20px; font-size: 20px;" align-center>
            <p>{{message}}</p>

          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="green" @click="dialog = !dialog">OK</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center" style="margin-left: unset;">
          <v-col cols="12" sm="12" md="12">
            <div>
              <h1
                style="text-align: center; color: white; letter-spacing: 6px!important; font-size: 50px; line-height: 57px;"
              >COMING SOON</h1>
              <p
                style="color: white; text-align: center; font-size: 20px; letter-spacing: 2.5px; margin-top: 10px;"
              >Our website is currently updating, follow us for update now!</p>
            </div>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="4" md="4" xs="6">
                  <v-text-field
                    :rules="requiredRules"
                    required
                    v-model="name"
                    background-color="white"
                    label
                    outlined
                    placeholder="Name (Required)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" xs="6">
                  <v-text-field
                    :rules="requiredRules"
                    required
                    v-model="email"
                    background-color="white"
                    label
                    outlined
                    placeholder="Email (Required)"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <div style="height: 50px; text-align: center;">
                    <v-btn
                      width="150"
                      height="55"
                      class
                      :loading="loading"
                      depressed
                      color="error"
                      @click="submit"
                    >Get Updates</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";

export default {
  data: function() {
    return {
      valid: false,
      name: "",
      email: "",
      requiredRules: [v => !!v || ""],
      loading: false,
      dialog: false,
      status: 'Success',
      message: 'success'
    };
  },
  props: {
    source: String
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        var self = this;
        self.loading = true;
        firebase
          .database()
          .ref("users")
          .push({
            email: self.email,
            name: self.name
          })
          .then(() => {
            self.$refs.form.reset();
            self.loading = false;
            self.dialog = true;
            self.message = 'Thank you for subscribing'
            self.status = 'Success'
          })
          .catch(error => {
            self.loading = false;
            self.dialog = true;
            self.message = error;
            self.status = 'Error'
          });
      }
    }
  }
};
</script>
<style>
.v-input__control {
  height: 50px !important;
}
</style>